import React from "react";

/**
 * A single Revenue Path node, rendered inline so sections can speak the same
 * visual grammar as the full RevenuePath SVG without repeating the whole asset.
 *
 * States mirror RevenuePath: healthy | friction | leak | broken | recovered.
 * Champagne is the signal color; olive reads as the "recovered/positive" tone
 * inside the warm sand palette.
 */

const CHAMPAGNE = "#C2A36B";
const INK = "#0A0A0B";
const IVORY = "#F9F8F3";
const MUTED = "#B8B1A2";

export default function NodeGlyph({ state = "healthy", size = 22, className = "" }) {
  const c = size / 2;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      data-testid={`node-glyph-${state}`}
      aria-hidden="true"
    >
      {state === "leak" && (
        <>
          <circle cx="12" cy="9.5" r="5" fill={IVORY} stroke={CHAMPAGNE} strokeWidth="1.6" strokeDasharray="3 3" />
          <circle cx="12" cy="18" r="1.4" fill={CHAMPAGNE} opacity="0.75" />
          <circle cx="13.6" cy="22" r="1" fill={CHAMPAGNE} opacity="0.45" />
        </>
      )}
      {state === "broken" && (
        <>
          <circle cx="12" cy="12" r="5.5" fill={IVORY} stroke={MUTED} strokeWidth="1.4" />
          <line x1="9" y1="9" x2="15" y2="15" stroke={MUTED} strokeWidth="1.4" />
          <line x1="15" y1="9" x2="9" y2="15" stroke={MUTED} strokeWidth="1.4" />
        </>
      )}
      {state === "friction" && (
        <circle cx="12" cy="12" r="5.5" fill={IVORY} stroke={INK} strokeWidth="1.6" strokeDasharray="1.6 2.4" />
      )}
      {state === "recovered" && (
        <>
          <circle cx="12" cy="12" r="8.5" fill="none" stroke={CHAMPAGNE} strokeWidth="1" opacity="0.4" />
          <circle cx="12" cy="12" r="5.5" fill={CHAMPAGNE} stroke={CHAMPAGNE} strokeWidth="1" />
        </>
      )}
      {state === "healthy" && (
        <circle cx="12" cy="12" r="5" fill={INK} stroke={INK} strokeWidth="1" />
      )}
    </svg>
  );
}
